/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'react-router-dom';

import { COPIES, LINKS } from '../../../../constants';
import styles from './styles.module.scss';

const TeamCard = ({ id, count }) => (
    <Link to={`/${LINKS.TEAMS}/${id}`} className={styles.teamCardLink}>
        <h3 className={styles.teamCardTitle}>{COPIES.teams[id]}</h3>

        <p className={styles.teamCardCounter}>{`${count} ${COPIES.openings}`}</p>

        <p className={styles.teamCardDescription}>{COPIES.teamsDescriptions[id]}</p>
    </Link>
);

export default TeamCard;
